// extracted by mini-css-extract-plugin
export var container = "_5f-1";
export var cornerButtonContainer = "_5f-5";
export var disabled = "_5f-2";
export var fileContainer = "_5f-4";
export var hiddenInput = "_5f-3";
export var widthContainer = "_5f-0";